export const Home = 'Home';
export const Products = 'Products';
export const About = 'About';
export const TermsConditions = 'TermsConditions';
export const Policy = 'Policy';
export const FAQs = 'FAQs';
export const Blogs = 'Blogs';
export const OurBlogs = 'OurBlogs';
export const OurIngredients = 'OurIngredients';
export const ContactUs_ = 'ContactUs_';
export const Partner = 'Partner';
export const SubscribeNow = 'SubscribeNow';
export const RecentPost = 'RecentPost';
export const UsefulLinks = 'UsefulLinks';
export const StayConnected = 'StayConnected';
export const SubscribeFirstPurchase = 'SubscribeFirstPurchase';
export const HomeTitle1 = 'HomeTitle1';
export const HomeTitle2 = 'HomeTitle2';
export const HomeTitle3 = 'HomeTitle3';

export const MixedIn = 'MixedIn';
export const TakeTheTestButton = 'TakeTheTestButton';
export const HomeTakeTestButton = 'HomeTakeTestButton';
export const ProducedIn = 'ProducedIn';
export const SatisfactionGuaranteeTitle = 'SatisfactionGuaranteeTitle';
export const SatisfactionGuaranteeDesc = 'SatisfactionGuaranteeDesc';
export const AsSeenIn = 'AsSeenIn';
export const WhatAreYourWellnessGoals = 'WhatAreYourWellnessGoals';
export const Vegan = 'Vegan';
export const SuitableForAthletes = 'SuitableForAthletes';
export const GlutenFree = 'GlutenFree';
export const ColorantFree = 'ColorantFree';
export const ItMattersToUs = 'ItMattersToUs';

export const FreeInclude1 = 'FreeInclude1';
export const FreeInclude2 = 'FreeInclude2';
export const FreeInclude3 = 'FreeInclude3';
export const Payments = 'Payments';
export const FollowUs = 'FollowUs';
export const TakeTheTest = 'TakeTheTest';
export const TakeATest = 'TakeATest';
export const DiscountCodes = 'DiscountCodes';
export const Login = 'Login';
export const LogoutTitle = 'Logout';
export const LoggedOut = 'LoggedOut';
export const EnterEmailHere = 'EnterEmailHere';
export const Ingredients = 'Ingredients';
export const HeaderIngredients = 'Header_Ingredients';
export const Cart = 'Cart';

export const CancelAnytimeLabel = 'CancelAnytimeLabel';
export const CancelAnytimeAnswer = 'CancelAnytimeAnswer';
export const DoINeedAboLabel = 'DoINeedAboLabel';
export const DoINeedAboAnswer = 'DoINeedAboAnswer';

export const AnyOtherQuestion = 'AnyOtherQuestion';

export const EmailAddress = 'EmailAddress';
export const ContactDetails = 'ContactDetails';
export const Address = 'Address';

export const SendInquiry = 'SendInquiry';
export const FirstName = 'FirstName';
export const LastName = 'LastName';
export const Phone = 'Phone';
export const Email = 'Email';
export const Message = 'Message';

export const Previous = 'Previous';
export const YourFocusAreas = 'YourFocusAreas';
export const MyFocusArea = 'MyFocusArea';
export const YourFocusAreasDesc = 'YourFocusAreasDesc';
export const ProductSuggestionEyebrow = 'ProductSuggestionEyebrow';
export const ProductSuggestionReviewFrom = 'ProductSuggestionReviewFrom';
export const ProductSuggestionReviewReviews = 'ProductSuggestionReviewReviews';
export const ProductSuggestionDoses = 'ProductSuggestionDoses';
export const ProductSuggestionImprovementBadge = 'ProductSuggestionImprovementBadge';
export const ProductSuggestionIngredientsBadge = 'ProductSuggestionIngredientsBadge';
export const MainPurposeSublineFeelBest = 'MainPurposeSubline_FeelBest';
export const MainPurposeSublineReplaceSupplements = 'MainPurposeSubline_ReplaceSupplements';
export const MainPurposeSublineSpecificNeeds = 'MainPurposeSubline_SpecificNeeds';
export const MainPurposeSublineFillGaps = 'MainPurposeSubline_FillGaps';
export const MainPurposeSublineFillGapsNoConditions = 'MainPurposeSubline_FillGapsNoConditions';
export const MainPurposeSublineStopPills = 'MainPurposeSubline_StopPills';
export const MainPurposeProfileFallback = 'MainPurposeProfile_Fallback';
export const MainPurposeProfileMale = 'MainPurposeProfile_Male';
export const MainPurposeProfileFemale = 'MainPurposeProfile_Female';
export const MainPurposeProfilePerson = 'MainPurposeProfile_Person';
export const MainPurposeHealthGoalOne = 'MainPurposeHealthGoal_One';
export const MainPurposeHealthGoalOther = 'MainPurposeHealthGoal_Other';
export const MainPurposePersonalSignalOne = 'MainPurposePersonalSignal_One';
export const MainPurposePersonalSignalOther = 'MainPurposePersonalSignal_Other';
export const MainPurposeConditionOne = 'MainPurposeCondition_One';
export const MainPurposeConditionOther = 'MainPurposeCondition_Other';
export const PersonalizedFormula = 'PersonalizedFormula';
export const PersonalizedFormulaDesc = 'PersonalizedFormulaDesc';
export const IncludesIngredients = 'IncludesIngredients';
export const Nutrient = 'Nutrient';
export const Quantity = 'Quantity';
export const SubscriptionOptions = 'SubscriptionOptions';
export const SubscriptionDetailsLine = 'SubscriptionDetailsLine';
export const ChooseYourPlan = 'ChooseYourPlan';
export const ContinueMyCart = 'ContinueMyCart';
export const Subscription = 'Subscription';

export const CheckOut_ = 'CheckOut_';
export const CheckOut__ = 'CheckOut__';
export const YourSupplements = 'YourSupplements';
export const CapsulePerDay = 'CapsulePerDay';
export const YourOrder = 'YourOrder';
export const SubTotal = 'SubTotal';
export const AfterDiscount = 'AfterDiscount';
export const Shipping = 'Shipping';
export const Total = 'Total';
export const Submit = 'Submit';
export const Cancel = 'Cancel';

export const RecipientDetails_ = 'RecipientDetails';
export const CompanyName = 'CompanyName';
export const ShippingDetails = 'ShippingDetails';
export const CountryRegion = 'CountryRegion';
export const StreetAddress = 'StreetAddress';
export const Apartment = 'Apartment';
export const State = 'State';
export const Zipcode = 'Zipcode';

export const Accepted = 'Accepted';

export const Box1mLine1 = 'Box1mLine1';
export const Box1mLine2 = 'Box1mLine2';
export const Box1mLine3 = 'Box1mLine3';
export const Box1mLine4 = 'Box1mLine4';
export const Box3mLine1 = 'Box3mLine1';
export const Box3mLine2 = 'Box3mLine2';
export const Box3mLine3 = 'Box3mLine3';
export const Box3mLine4 = 'Box3mLine4';
export const Box6mLine1 = 'Box6mLine1';
export const Box6mLine2 = 'Box6mLine2';
export const Box6mLine3 = 'Box6mLine3';
export const Box6mLine4 = 'Box6mLine4';

export const UserDashboard = 'UserDashboard';
export const DashboardTitle = 'Dashboard';

export const ReferralCode = 'ReferralCode';
export const Profile = 'Profile';
export const MyOrders = 'MyOrders';
export const ChangePassword = 'ChangePassword';
export const InquiryTitle = 'Inquiry';
export const CheckIn = 'CheckIn';
export const TotalCheckIns = 'TotalCheckIns';
export const FeelingText = 'FeelingText';
export const AskSpecialist = 'AskSpecialist';
export const Hello = 'Hello';
export const WelcomeMessage = 'WelcomeMessage';
export const Hi = 'Hi';

export const Referrals = 'Referrals';
export const RetakeTest = 'RetakeTest';

export const ManageSubscription = 'ManageSubscription';
export const CustomerService = 'CustomerService';
export const Benefits = 'Benefits';

export const FreeShippingWithSubscription = 'FreeShippingWithSubscription';
export const Rating = 'Rating';
export const ResetButton = 'ResetButton';
export const AddButton = 'AddButton';
export const IngredientsOverlay = 'IngredientsOverlay';
export const Ingredients1 = 'Ingredients1';
export const ChooseYourPlan1 = 'ChooseYourPlan1';
export const TryOnce = 'TryOnce';
export const MonthlyPlan = 'MonthlyPlan';
export const ThreeMonthPlan = 'ThreeMonthPlan';
export const Save10Percent = 'Save10Percent';
export const Save25Percent = 'Save25Percent';
export const SelectAPlanMobile = 'SelectAPlanMobile';
export const StartNowButton = 'StartNowButton';
export const SecurePayment = 'SecurePayment';
export const ShippedIn2To3Days = 'ShippedIn2To3Days';
export const Verified = 'Verified';
export const CustomerReviews = 'CustomerReviews';
export const CustomerReviewsDesc = 'CustomerReviewsDesc';
export const Reviews = 'Reviews';
export const FormulatedByExperts = 'FormulatedByExperts';
export const FormulaHeading = 'FormulaHeading';
export const Available = 'Available';
export const AvailableText = 'AvailableText';
export const PerDay = 'PerDay';
export const Month = 'Month';
export const Selected = 'Selected';
export const Select = 'Select';
export const MostPopular = 'MostPopular';
export const BestValue = 'BestValue';
export const HereMainHeading = 'HereMainHeading';
export const HereMainHeading2 = 'HereMainHeading2';
export const HereHeading1 = 'HereHeading1';
export const HereHeading2 = 'HereHeading2';
export const HereHeading3 = 'HereHeading3';
export const HereDesc1 = 'HereDesc1';
export const HereDesc2 = 'HereDesc2';
export const HereDesc3 = 'HereDesc3';
export const PersonaliseMine = 'PersonaliseMine';
export const Personalised = 'Personalised';
export const Neil = 'Neil';
export const Chris = 'Chris';
export const Adina = 'Adina';
export const TryOnceBox1 = 'TryOnceBox1';
export const TryOnceBox2 = 'TryOnceBox2';
export const TryOnceBox3 = 'TryOnceBox3';
export const Reformulation = 'Reformulation';
export const FreeShipping = 'FreeShipping';
export const FreeShippingInEu = 'FreeShippingInEu';
export const DiscountBannerText = 'DiscountBannerText';
export const GetOff = 'GetOff';
export const ProductInfo1 = 'ProductInfo1';
export const ProductInfo2 = 'ProductInfo2';
export const ProductInfo3 = 'ProductInfo3';
export const ProductInfo4 = 'ProductInfo4';
export const ProductInfo5 = 'ProductInfo5';
export const FreeShippingBanner = 'FreeShippingBanner';
export const Off25 = 'Off25';
export const BenefitCarrotCareHeading = 'BenefitCarrotCareHeading';
export const BenefitCarrotCareDesc = 'BenefitCarrotCareDesc';
export const BenefitLifeLabHeading = 'BenefitLifeLabHeading';
export const BenefitLifeLabDesc = 'BenefitLifeLabDesc';
export const Energy = 'Energy';
export const Focus = 'Focus';
export const SportPerformance = 'SportPerformance';
export const Mood = 'Mood';
export const Sleep = 'Sleep';
export const Stress = 'Stress';
export const Digestion = 'Digestion';
export const ImmuneSystem = 'ImmuneSystem';
export const Skin = 'Skin';
export const Hair = 'Hair';
export const Nails = 'Nails';
export const Heart = 'Heart';
export const MusclePain = 'MusclePain';
export const Eyes = 'Eyes';
export const BonesAndJoints = 'BonesAndJoints';
export const You = 'You';
export const Your = 'Your';
export const BannerHeading1 = 'BannerHeading1';
export const BannerHeading2 = 'BannerHeading2';
export const BannerText1 = 'BannerText1';
export const BannerText2 = 'BannerText2';
export const UniqueHeading = 'UniqueHeading';
export const NoArtificialCloning = 'NoArtificialCloning';
export const UniqueSlide1Heading = 'UniqueSlide1Heading';
export const UniqueSlide1Desc = 'UniqueSlide1Desc';
export const UniqueSlide2Heading = 'UniqueSlide2Heading';
export const UniqueSlide2Desc = 'UniqueSlide2Desc';
export const UniqueSlide2DescLearnMore = 'UniqueSlide2DescLearnMore';
export const UniqueSlide3Heading = 'UniqueSlide3Heading';
export const UniqueSlide3Desc = 'UniqueSlide3Desc';
export const HighStandardHeading = 'HighStandardHeading';
export const HighStandardDesc1 = 'HighStandardDesc1';
export const HighStandardDesc2 = 'HighStandardDesc2';
export const HighStandardDesc3 = 'HighStandardDesc3';
export const EachActive = 'EachActive';
export const MillionCombinations1 = 'MillionCombinations1';
export const MillionCombinations2 = 'MillionCombinations2';
export const MillionCombinations3 = 'MillionCombinations3';
export const RecommendationButton = 'RecommendationButton';
export const MakeChoiceHeading = 'MakeChoiceHeading';
export const MakeChoiceFeature = 'MakeChoiceFeature';
export const TableRow1 = 'TableRow1';
export const TableRow2 = 'TableRow2';
export const TableRow3 = 'TableRow3';
export const TableRow4 = 'TableRow4';
export const TableRow5 = 'TableRow5';
export const TableRow6 = 'TableRow6';
export const TableRow7 = 'TableRow7';
export const PartnersHeading = 'PartnersHeading';
export const EnergyBanner1 = 'EnergyBanner1';
export const EnergyBanner2 = 'EnergyBanner2';
export const EnergyDesc1 = 'EnergyDesc1';
export const EnergyDesc2 = 'EnergyDesc2';
export const EnergyDesc3 = 'EnergyDesc3';
export const EnergyDesc4 = 'EnergyDesc4';
export const QuizButton = 'QuizButton';
export const SupportEnergy = 'SupportEnergy';
export const SupportEnergyDesc1 = 'SupportEnergyDesc1';
export const SupportEnergyDesc2 = 'SupportEnergyDesc2';
export const NutirentsBodyNeed = 'NutirentsBodyNeed';
export const Magnesium = 'Magnesium';
export const MagnesiumDesc = 'MagnesiumDesc';
export const MagnesiumDetail1 = 'MagnesiumDetail1';
export const MagnesiumDetail2 = 'MagnesiumDetail2';
export const VitaminB12 = 'VitaminB12';
export const VitaminB12Desc = 'VitaminB12Desc';
export const VitaminB12Detail1 = 'VitaminB12Detail1';
export const VitaminB12Detail2 = 'VitaminB12Detail2';
export const Iron = 'Iron';
export const IronDesc = 'IronDesc';
export const IronDetail1 = 'IronDetail1';
export const IronDetail2 = 'IronDetail2';
export const VitaminD = 'VitaminD';
export const VitaminDDesc = 'VitaminDDesc';
export const VitaminDDetail1 = 'VitaminDDetail1';
export const VitaminDDetail2 = 'VitaminDDetail2';
export const Faq = 'Faq';
export const FaqMore = 'FaqMore';
export const FaqPage = 'FaqPage';
export const FocusHeader = 'FocusHeader';
export const FocusHeader1 = 'FocusHeader1';
export const FocusIntro = 'FocusIntro';
export const FocusFrustration = 'FocusFrustration';
export const FocusSupport = 'FocusSupport';
export const FocusVitamins = 'FocusVitamins';
export const FocusVitaminB1 = 'FocusVitaminB1';
export const FocusVitaminB6 = 'FocusVitaminB6';
export const FocusBiotin = 'FocusBiotin';
export const FocusFolate = 'FocusFolate';
export const FocusVitaminB1Second = 'FocusVitaminB1Second';
export const FocusVitaminB6Second = 'FocusVitaminB6Second';
export const FocusBiotinSecond = 'FocusBiotinSecond';
export const FocusFolateSecond = 'FocusFolateSecond';
export const SportsPerformanceHeader = 'SportsPerformanceHeader';
export const SportsPerformanceHeader1 = 'SportsPerformanceHeader1';
export const SportsPerformanceIntro = 'SportsPerformanceIntro';
export const SportsPerformanceSupport = 'SportsPerformanceSupport';
export const SportsPerformanceVitamins = 'SportsPerformanceVitamins';
export const SportsPerformanceMagnesium = 'SportsPerformanceMagnesium';
export const SportsPerformanceIron = 'SportsPerformanceIron';
export const SportsPerformanceB_Vitamins = 'SportsPerformanceB_Vitamins';
export const SportsPerformanceZinc = 'SportsPerformanceZinc';
export const SportsPerformanceMagnesiumSecond = 'SportsPerformanceMagnesiumSecond';
export const SportsPerformanceIronSecond = 'SportsPerformanceIronSecond';
export const SportsPerformanceB_VitaminsSecond = 'SportsPerformanceB_VitaminsSecond';
export const SportsPerformanceZincSecond = 'SportsPerformanceZincSecond';
export const SleepHeader = 'SleepHeader';
export const SleepHeader1 = 'SleepHeader1';
export const SleepDescription = 'SleepDescription';
export const SleepNutrientsHeader = 'SleepNutrientsHeader';
export const SleepMagnesium = 'SleepMagnesium';
export const SleepMagnesiumSecond = 'SleepMagnesiumSecond';
export const SleepVitaminB9 = 'SleepVitaminB9';
export const SleepVitaminB6 = 'SleepVitaminB6';
export const SleepZinc = 'SleepZinc';
export const SleepVitaminB9Second = 'SleepVitaminB9Second';
export const SleepVitaminB6Second = 'SleepVitaminB6Second';
export const SleepZincSecond = 'SleepZincSecond';
export const VitaminB6 = 'VitaminB6';
export const VitaminB6Desc = 'VitaminB6Desc';
export const VitaminB9 = 'VitaminB9';
export const VitaminB9Desc = 'VitaminB9Desc';
export const VitaminB1 = 'VitaminB1';
export const VitaminB1Desc = 'VitaminB1Desc';
export const Biotin = 'Biotin';
export const BiotinDesc = 'BiotinDesc';
export const Folate = 'Folate';
export const FolateDesc = 'FolateDesc';
export const Zinc = 'Zinc';
export const ZincDesc = 'ZincDesc';
export const BVitamins = 'BVitamins';
export const BVitaminsDesc = 'BVitaminsDesc';
export const Ashwagandha = 'Ashwagandha';
export const AshwagandhaDesc = 'AshwagandhaDesc';
export const VitaminC = 'VitaminC';
export const VitaminCDesc = 'VitaminCDesc';
export const Selenium = 'Selenium';
export const SeleniumDesc = 'SeleniumDesc';

export const StressHeader = 'StressHeader';
export const StressHeader1 = 'StressHeader1';
export const StressDescription = 'StressDescription';
export const StressNutrientsHeader = 'StressNutrientsHeader';
export const StressNutrientsHeader1 = 'StressNutrientsHeader1';
export const StressMagnesium = 'StressMagnesium';
export const StressMagnesiumSecond = 'StressMagnesiumSecond';
export const StressBVitamins = 'StressBVitamins';
export const StressBVitaminsSecond = 'StressBVitaminsSecond';
export const StressAshwagandha = 'StressAshwagandha';
export const StressAshwagandhaSecond = 'StressAshwagandhaSecond';
export const StressVitaminC = 'StressVitaminC';
export const StressVitaminCSecond = 'StressVitaminCSecond';

export const MoodHeader = 'MoodHeader';
export const MoodHeader1 = 'MoodHeader1';
export const MoodDescription = 'MoodDescription';
export const MoodDescription1 = 'MoodDescription1';
export const MoodNutrientsHeader = 'MoodNutrientsHeader';
export const MoodNutrientsHeader1 = 'MoodNutrientsHeader1';
export const MoodMagnesium = 'MoodMagnesium';
export const MoodMagnesiumSecond = 'MoodMagnesiumSecond';
export const MoodVitaminB9 = 'MoodVitaminB9';
export const MoodVitaminB9Second = 'MoodVitaminB9Second';
export const MoodVitaminD = 'MoodVitaminD';
export const MoodVitaminDSecond = 'MoodVitaminDSecond';
export const MoodVitaminB12 = 'MoodVitaminB12';
export const MoodVitaminB12Second = 'MoodVitaminB12Second';

export const ImmuneSystemHeader = 'ImmuneSystemHeader';
export const ImmuneSystemHeader1 = 'ImmuneSystemHeader1';
export const ImmuneSystemDescription = 'ImmuneSystemDescription';
export const ImmuneSystemDescription1 = 'ImmuneSystemDescription1';
export const ImmuneSystemNutrientsHeader = 'ImmuneSystemNutrientsHeader';
export const ImmuneSystemNutrientsHeader1 = 'ImmuneSystemNutrientsHeader1';
export const ImmuneSystemVitaminD = 'ImmuneSystemVitaminD';
export const ImmuneSystemVitaminDSecond = 'ImmuneSystemVitaminDSecond';
export const ImmuneSystemVitaminC = 'ImmuneSystemVitaminC';
export const ImmuneSystemVitaminCSecond = 'ImmuneSystemVitaminCSecond';
export const ImmuneSystemZinc = 'ImmuneSystemZinc';
export const ImmuneSystemZincSecond = 'ImmuneSystemZincSecond';
export const ImmuneSystemSelenium = 'ImmuneSystemSelenium';
export const ImmuneSystemSeleniumSecond = 'ImmuneSystemSeleniumSecond';

export const SupportFocus = 'SupportFocus';
export const SupportSportPerformance = 'SupportSportPerformance';
export const SupportSleep = 'SupportSleep';
export const SupportStress = 'SupportStress';
export const SupportMood = 'SupportMood';
export const SupportImmuneSystem = 'SupportImmuneSystem';
export const CountdownText = 'CountdownText';

export const RefillBannerHeading = 'RefillBannerHeading';
export const RefillBannerDesc1 = 'RefillBannerDesc1';
export const RefillBannerDesc2 = 'RefillBannerDesc2';
export const RefillBannerDesc3 = 'RefillBannerDesc3';
export const RefillBannerDesc4 = 'RefillBannerDesc4';
export const RefillInputPlaceholder = 'RefillInputPlaceholder';
export const RefillBtnText = 'RefillBtnText';
export const ReorderBtnText = 'ReorderBtnText';
export const BuyWithNewQuizBtnText = 'BuyWithNewQuizBtnText';
export const PhaseHeading = 'PhaseHeading';
export const StartPhaseHeading = 'StartPhaseHeading';
export const StartPhaseDesc1 = 'StartPhaseDesc1';
export const StartPhaseDesc2 = 'StartPhaseDesc2';
export const StartPhaseDuration = 'StartPhaseDuration';
export const StartPhaseDurationTime = 'StartPhaseDurationTime';
export const RoutinePhaseHeading = 'RoutinePhaseHeading';
export const RoutinePhaseDesc1 = 'RoutinePhaseDesc1';
export const RoutinePhaseDesc2 = 'RoutinePhaseDesc2';
export const RoutinePhaseDurationTime = 'RoutinePhaseDurationTime';
export const SuccessPhaseHeading = 'SuccessPhaseHeading';
export const SuccessPhaseDesc1 = 'SuccessPhaseDesc1';
export const SuccessPhaseDesc2 = 'SuccessPhaseDesc2';
export const SuccessPhaseDurationTime = 'SuccessPhaseDurationTime';
export const HelpPhaseHeading = 'HelpPhaseHeading';
export const HelpPhaseDesc1 = 'HelpPhaseDesc1';
export const HelpPhaseDesc2 = 'HelpPhaseDesc2';
export const BestEnjoyHeading = 'BestEnjoyHeading';
export const BestEnjoyDesc = 'BestEnjoyDesc';
export const BestEnjoy1 = 'BestEnjoy1';
export const BestEnjoy2 = 'BestEnjoy2';
export const BestEnjoy3 = 'BestEnjoy3';
export const Histamin = 'Histamin';
export const FreeShippingMobile = 'FreeShippingMobile';
export const CancelAnytimeMobile = 'CancelAnytimeMobile';
export const MysteryHeading = 'MysteryHeading';
export const MysterySubHeading = 'MysterySubHeading';
export const MysteryApplyCode = 'MysteryApplyCode';
export const FounderQuote = 'FounderQuote';
export const FounderAttribution = 'FounderAttribution';
export const LisaSectionEyebrow = 'LisaSectionEyebrow';
export const LisaSectionHeading = 'LisaSectionHeading';
export const BoomTestimonial = 'BoomTestimonial';
export const BoomTestimonial1Name = 'BoomTestimonial1Name';
export const BoomTestimonial1Review = 'BoomTestimonial1Review';
export const BoomTestimonial2Name = 'BoomTestimonial2Name';
export const BoomTestimonial2Review = 'BoomTestimonial2Review';
export const BoomTestimonial3Name = 'BoomTestimonial3Name';
export const BoomTestimonial3Review = 'BoomTestimonial3Review';
export const BoomTestimonial4Name = 'BoomTestimonial4Name';
export const BoomTestimonial4Review = 'BoomTestimonial4Review';
export const BoomTestimonial5Name = 'BoomTestimonial5Name';
export const BoomTestimonial5Review = 'BoomTestimonial5Review';
export const BoomTestimonial6Name = 'BoomTestimonial6Name';
export const BoomTestimonial6Review = 'BoomTestimonial6Review';
export const BoomTestimonial7Name = 'BoomTestimonial7Name';
export const BoomTestimonial7Review = 'BoomTestimonial7Review';
export const BoomTestimonial8Name = 'BoomTestimonial8Name';
export const BoomTestimonial8Review = 'BoomTestimonial8Review';
export const BoomTestimonial9Name = 'BoomTestimonial9Name';
export const BoomTestimonial9Review = 'BoomTestimonial9Review';
export const BoomTestimonial10Name = 'BoomTestimonial10Name';
export const BoomTestimonial10Review = 'BoomTestimonial10Review';
export const BoomTagSports = 'BoomTagSports';
export const BoomTagRecovery = 'BoomTagRecovery';
export const BoomTagEnergy = 'BoomTagEnergy';
export const BoomTagSleep = 'BoomTagSleep';
export const BoomTagFocus = 'BoomTagFocus';
export const BoomTagStress = 'BoomTagStress';
export const BoomTagNails = 'BoomTagNails';
export const BoomTagImmunity = 'BoomTagImmunity';
export const BoomTagDigestion = 'BoomTagDigestion';
export const BoomTagSachet = 'BoomTagSachet';
export const BoomTagConsistency = 'BoomTagConsistency';
// Short overlay captions for the product-suggestion page. Deliberately separate
// from the BoomTestimonial reviews, which stay long-form in the home carousel.
export const PdpTestimonialsTitle = 'PdpTestimonialsTitle';
export const PdpQuoteKarin = 'PdpQuoteKarin';
export const PdpQuoteLisa = 'PdpQuoteLisa';
export const PdpQuoteJanine = 'PdpQuoteJanine';
export const PdpQuoteChris = 'PdpQuoteChris';
export const AmbassadorsPill = 'AmbassadorsPill';
export const AmbassadorsHeading = 'AmbassadorsHeading';
export const AmbassadorsHeadingEmphasis = 'AmbassadorsHeadingEmphasis';
export const AmbassadorsSubheading = 'AmbassadorsSubheading';
export const AmbassadorsStat1 = 'AmbassadorsStat1';
export const AmbassadorsStat2 = 'AmbassadorsStat2';
export const Ambassador1Name = 'Ambassador1Name';
export const Ambassador1Title = 'Ambassador1Title';
export const Ambassador1Desc = 'Ambassador1Desc';
export const Ambassador2Name = 'Ambassador2Name';
export const Ambassador2Title = 'Ambassador2Title';
export const Ambassador2Desc = 'Ambassador2Desc';
export const Ambassador3Name = 'Ambassador3Name';
export const Ambassador3Title = 'Ambassador3Title';
export const Ambassador3Desc = 'Ambassador3Desc';
export const Ambassador4Name = 'Ambassador4Name';
export const Ambassador4Title = 'Ambassador4Title';
export const Ambassador4Desc = 'Ambassador4Desc';
export const SocialProofText = 'SocialProofText';
export const BasedOnYourQuiz = 'BasedOnYourQuiz';
export const Actives = 'Actives';
export const NewCustomerOffer = 'NewCustomerOffer';
export const Percentage = 'Percentage';
export const ExtraOff = 'ExtraOff';
export const Code = 'Code';
export const Ein = 'Ein';
export const Free = 'Free';
export const NutritionistAccess = 'NutritionistAccess';
export const WelcomeKit = 'WelcomeKit';
export const AndMore = 'AndMore';
export const YouAre = 'YouAre';
export const Saving = 'Saving';
export const InAverage = 'InAverage';
export const WhatAreYouGetting = 'WhatAreYouGetting';
export const OrderNow = 'OrderNow';
export const ProductBuyNow = 'Product_BuyNow';
export const ProductBuyNowPrice = 'Product_BuyNow_Price';
export const ProductPricePerDay = 'Product_PricePerDay';
export const ProductFreeShippingStrikethrough = 'Product_FreeShipping_Strikethrough';
export const ProductQuizEyebrow = 'Product_QuizEyebrow';
export const ProductQuizTrust = 'Product_QuizTrust';
export const QuizFirstSlideTitle = 'QuizFirstSlideTitle';
export const QuizFirstSlideDesc1 = 'QuizFirstSlideDesc1';
export const QuizFirstSlideDesc2 = 'QuizFirstSlideDesc2';

export const SFEnergyTitle = 'SFEnergyTitle';
export const SFEnergyDesc = 'SFEnergyDesc';
export const SFEnergyBenefit1 = 'SFEnergyBenefit1';
export const SFEnergyBenefit2 = 'SFEnergyBenefit2';
export const SFEnergyBenefit3 = 'SFEnergyBenefit3';

export const SFImmuneSystemTitle = 'SFImmuneSystemTitle';
export const SFImmuneSystemDesc = 'SFImmuneSystemDesc';
export const SFImmuneSystemBenefit1 = 'SFImmuneSystemBenefit1';
export const SFImmuneSystemBenefit2 = 'SFImmuneSystemBenefit2';
export const SFImmuneSystemBenefit3 = 'SFImmuneSystemBenefit3';

export const SFBeautyTitle = 'SFBeautyTitle';
export const SFBeautyDesc = 'SFBeautyDesc';
export const SFBeautyBenefit1 = 'SFBeautyBenefit1';
export const SFBeautyBenefit2 = 'SFBeautyBenefit2';
export const SFBeautyBenefit3 = 'SFBeautyBenefit3';

export const SFSleepTitle = 'SFSleepTitle';
export const SFSleepDesc = 'SFSleepDesc';
export const SFSleepBenefit1 = 'SFSleepBenefit1';
export const SFSleepBenefit2 = 'SFSleepBenefit2';
export const SFSleepBenefit3 = 'SFSleepBenefit3';

export const SFSportsRecoveryTitle = 'SFSportsRecoveryTitle';
export const SFSportsRecoveryDesc = 'SFSportsRecoveryDesc';
export const SFSportsRecoveryBenefit1 = 'SFSportsRecoveryBenefit1';
export const SFSportsRecoveryBenefit2 = 'SFSportsRecoveryBenefit2';
export const SFSportsRecoveryBenefit3 = 'SFSportsRecoveryBenefit3';

export const SFStressTitle = 'SFStressTitle';
export const SFStressDesc = 'SFStressDesc';
export const SFStressBenefit1 = 'SFStressBenefit1';
export const SFStressBenefit2 = 'SFStressBenefit2';
export const SFStressBenefit3 = 'SFStressBenefit3';
export const TailoredToYou = 'TailoredToYou';
export const TailoredToYouPre = 'TailoredToYouPre';
export const TailoredToYouEmphasis = 'TailoredToYouEmphasis';
export const TailoredToYouPost = 'TailoredToYouPost';
export const TailoredToYouDesc = 'TailoredToYouDesc';
export const SmartFormulasHeading = 'SmartFormulasHeading';
export const HowToTake = 'HowToTake';
export const EnergyFA = 'EnergyFA';
export const ImmuneSystemFA = 'ImmuneSystemFA';
export const BeautyFA = 'BeautyFA';
export const SleepFA = 'SleepFA';
export const SportsFA = 'SportsFA';
export const StressFA = 'StressFA';
export const SelectYourGoal = 'SelectYourGoal';
export const PersonalizeIt = 'PersonalizeIt';
export const Shop = 'Shop';
export const ProductsHeader = 'ProductsHeader';
export const ExploreSmartFormulas = 'ExploreSmartFormulas';
export const NeedHelp = 'NeedHelp';
export const Take5MinQuiz = 'Take5MinQuiz';
export const Days = 'Days';

// Products page v2 — formula category tags
export const TagEnergy = 'TagEnergy';
export const TagImmunity = 'TagImmunity';
export const TagBeauty = 'TagBeauty';
export const TagStress = 'TagStress';
export const TagPerformance = 'TagPerformance';
export const TagSleep = 'TagSleep';

// Products page v2
export const ProdSectionQuiz = 'ProdSectionQuiz';
export const ProdSectionQuizSub = 'ProdSectionQuizSub';
export const ProdSectionFormulas = 'ProdSectionFormulas';
export const ProdSectionFormulasSub = 'ProdSectionFormulasSub';
export const ProdSectionAddons = 'ProdSectionAddons';
export const ProdSectionAddonsSub = 'ProdSectionAddonsSub';
export const ProdFormulasLabel = 'ProdFormulasLabel';
export const ProdFormulasTitle = 'ProdFormulasTitle';
export const ProdFormulasSub = 'ProdFormulasSub';
export const ProdQuizNudge = 'ProdQuizNudge';
export const ProdQuizNudgeCTA = 'ProdQuizNudgeCTA';
export const ProdAddonsLabel = 'ProdAddonsLabel';
export const ProdAddonsTitle = 'ProdAddonsTitle';
export const ProdAddonsSub = 'ProdAddonsSub';
export const EnergyDesc = 'EnergyDesc';
export const ImmuneSystemDesc = 'ImmuneSystemDesc';
export const BeautyDesc = 'BeautyDesc';
export const StressDesc = 'StressDesc';
export const PerformanceDesc = 'PerformanceDesc';
export const SleepDesc = 'SleepDesc';
export const Days30 = 'Days30';
export const Omega3New = 'Omega3New';
export const Omega3Title = 'Omega3Title';
export const Omega3Tagline = 'Omega3Tagline';
export const Omega3Spec1 = 'Omega3Spec1';
export const Omega3Spec2 = 'Omega3Spec2';
export const Omega3Spec3 = 'Omega3Spec3';
export const Omega3Spec4 = 'Omega3Spec4';
export const Omega3CTA = 'Omega3CTA';
export const Omega3Stat1Val = 'Omega3Stat1Val';
export const Omega3Stat1Lbl = 'Omega3Stat1Lbl';
export const Omega3Stat1Note = 'Omega3Stat1Note';
export const Omega3Stat2Val = 'Omega3Stat2Val';
export const Omega3Stat2Lbl = 'Omega3Stat2Lbl';
export const Omega3Stat2Note = 'Omega3Stat2Note';
export const Omega3Stat3Val = 'Omega3Stat3Val';
export const Omega3Stat3Lbl = 'Omega3Stat3Lbl';
export const Omega3Stat3Note = 'Omega3Stat3Note';
export const Omega3Cert = 'Omega3Cert';
export const ProdComingSoon1 = 'ProdComingSoon1';
export const ProdComingSoon1Sub = 'ProdComingSoon1Sub';
export const ProdComingSoon2 = 'ProdComingSoon2';
export const ProdComingSoon2Sub = 'ProdComingSoon2Sub';

export const NutrientsCarousel = 'NutrientsCarousel';
export const IncludesCarousel = 'IncludesCarousel';
export const ViewFormula = 'ViewFormula';
export const ReformulationGuarantee = 'ReformulationGuarantee';
export const VeganVCP = 'VeganVCP';
export const FreeGifts = 'FreeGifts';
export const OneTime = 'OneTime';
export const Monthly = 'Monthly';
export const EveryThreeMonths = 'EveryThreeMonths';
export const ThreeMonths = 'ThreeMonths';

export const PartnerPageTitle = 'PartnerPageTitle';
export const PartnerPageDesc = 'PartnerPageDesc';
export const Section1Heading = 'Section1Heading';
export const Section1Desc = 'Section1Desc';
export const Section1Point1Title = 'Section1Point1Title';
export const Section1Point1Desc = 'Section1Point1Desc';
export const Section1Point2Title = 'Section1Point2Title';
export const Section1Point2Desc = 'Section1Point2Desc';
export const Section1Point3Title = 'Section1Point3Title';
export const Section1Point3Desc = 'Section1Point3Desc';
export const Section2Heading = 'Section2Heading';
export const Section2Desc = 'Section2Desc';
export const Section2Point1Title = 'Section2Point1Title';
export const Section2Point1Desc = 'Section2Point1Desc';
export const Section2Point2Title = 'Section2Point2Title';
export const Section2Point2Desc = 'Section2Point2Desc';
export const Section2Point3Title = 'Section2Point3Title';
export const Section2Point3Desc = 'Section2Point3Desc';
export const CaseStudy = 'CaseStudy';
export const CaseStudyHeading = 'CaseStudyHeading';
export const CaseStudyTitle = 'CaseStudyTitle';
export const CaseStudyDesc = 'CaseStudyDesc';

export const Practitioner = 'Practitioner';
export const DiscountBannerTextProductPage = 'DiscountBannerTextProductPage';
export const Off25ProductPage = 'Off25ProductPage';
export const FreeShippingBannerProductPage = 'FreeShippingBannerProductPage';

export const Servings = 'Servings';
export const Save = 'Save';
export const TryOnceMobile = 'TryOnceMobile';
export const Or = 'Or';
export const PauseAndCancel = 'PauseAndCancel';
export const SinglePurchase = 'SinglePurchase';
export const BestValueMobile = 'BestValueMobile';
export const LovedByNewCustomer = 'LovedByNewCustomer';
export const DailyServings = 'DailyServings';
export const FreeGiftsMobile = 'FreeGiftsMobile';
export const ThreeMonthsCourse = 'ThreeMonthsCourse';

export const TryOnce1 = 'TryOnce1';
export const TryOnceBox12 = 'TryOnceBox12';
export const Day = 'Day';
export const Hour = 'Hour';
export const Minute = 'Minute';
export const Second = 'Second';

export const HealthierPractitioner = 'HealthierPractitioner';
export const HealthierPractitionerP1 = 'HealthierPractitionerP1';
export const HealthierPractitionerP2 = 'HealthierPractitionerP2';
export const RegistrationText = 'RegistrationText';
export const RegisterHeading = 'RegisterHeading';
export const NeedHelpHaveQuestions = 'NeedHelpHaveQuestions';

export const Save10 = 'Save10';
export const CancelSkipEdit = 'CancelSkipEdit';
export const TryOnceMobileTitle = 'TryOnceMobileTitle';
export const NoPills = 'NoPills';
export const HeroH1Lead = 'HeroH1Lead';
export const HeroH1Tail = 'HeroH1Tail';
export const HeroSubline = 'HeroSubline';
export const HeroSocialProof = 'HeroSocialProof';
export const HeroCtaShort = 'HeroCtaShort';
export const Review1 = 'Review1';
export const Review2 = 'Review2';
export const Review3 = 'Review3';
export const Review4 = 'Review4';
export const ReviewRating = 'ReviewRating';
export const WhyRiiseEyebrow = 'WhyRiiseEyebrow';
export const WhyRiiseTitle = 'WhyRiise';
export const WhyRiiseHpTitle = 'WhyRiiseTitle';
export const WhyCard1Title = 'WhyCard1Title';
export const WhyCard1Body = 'WhyCard1Body';
export const WhyCard2Title = 'WhyCard2Title';
export const WhyCard2Body = 'WhyCard2Body';
export const WhyCard3Title = 'WhyCard3Title';
export const WhyCard3Body = 'WhyCard3Body';
export const LearnMoreArrow = 'LearnMoreArrow';
export const PersonalFormula = 'PersonalFormula';
export const PersonalFormulaReady = 'PersonalFormulaReady';
export const FormulaLoader_WelcomeBack = 'FormulaLoader_WelcomeBack';
export const FormulaLoader_LoadingFormula = 'FormulaLoader_LoadingFormula';
export const FormulaLoader_WorkingForYou = 'FormulaLoader_WorkingForYou';
export const FormulaLoader_Ready = 'FormulaLoader_Ready';
export const FormulaLoader_Line1 = 'FormulaLoader_Line1';
export const FormulaLoader_Line2 = 'FormulaLoader_Line2';
export const FormulaLoader_Line3 = 'FormulaLoader_Line3';
export const BestToStart = 'BestToStart';
export const ChristmasDiscount = 'ChristmasDiscount';
export const AutoApplied = 'AutoApplied';
export const RiskFree = 'RiskFree';
export const ResultsFeel = 'ResultsFeel';
export const ResultsFeelDesc1 = 'ResultsFeelDesc1';
export const ResultsFeelDesc2 = 'ResultsFeelDesc2';
export const ResultsCard1 = 'ResultsCard1';
export const ResultsCard2 = 'ResultsCard2';
export const RoutineStick = 'RoutineStick';
export const BuiltByScience = 'BuiltByScience';
export const ExpertDesc = 'ExpertDesc';
export const PhilippBio1 = 'PhilippBio1';
export const PhilippBio2 = 'PhilippBio2';
export const SeeMoreIng = 'SeeMoreIng';
export const OurIngredientsNew = 'OurIngredientsNew';

export const OurMission = 'OurMission';
export const SimpleSupplements = 'SimpleSupplements';
export const AboutUs1 = 'AboutUs1';
export const AboutUs2 = 'AboutUs2';
export const AboutUs3 = 'AboutUs3';
export const AboutUs4 = 'AboutUs4';
export const AboutUs5 = 'AboutUs5';
export const RiiseBuilt1 = 'RiiseBuilt1';
export const RiiseBuilt1Desc = 'RiiseBuilt1Desc';
export const RiiseBuilt2 = 'RiiseBuilt2';
export const RiiseBuilt2Desc = 'RiiseBuilt2Desc';
export const RiiseBuilt3 = 'RiiseBuilt3';
export const RiiseBuilt3Desc = 'RiiseBuilt3Desc';
export const RiiseBuilt4 = 'RiiseBuilt4';
export const RiiseBuilt4Desc = 'RiiseBuilt4Desc';
export const OurTeam = 'OurTeam';
export const OurTeamDesc1 = 'OurTeamDesc1';
export const OurTeamDesc2 = 'OurTeamDesc2';
export const OurTeamDesc3 = 'OurTeamDesc3';
export const HowRiiseMake = 'HowRiiseMake';

export const ThankYouForYourOrder = 'ThankYouForYourOrder';
export const WhatHappensNext = 'WhatHappensNext';
export const OrderNextSteps1 = 'OrderNextSteps1';
export const OrderNextSteps2 = 'OrderNextSteps2';
export const OrderNextSteps3 = 'OrderNextSteps3';
export const AnyQuestion = 'AnyQuestion';
export const HelpUs = 'HelpUs';
export const AnythingThatMade = 'AnythingThatMade';
export const TypeYourAnswer = 'TypeYourAnswer';
export const AnythingThatMadePlaceholder = 'AnythingThatMadePlaceholder';
export const GettingMostOutOfRiise = 'GettingMostOutOfRiise';
export const WelcomeOnboard = 'WelcomeOnboard';
export const MostCompanies = 'MostCompanies';
export const MostCompanies2 = 'MostCompanies2';
export const TeamPreparingOrder = 'TeamPreparingOrder';
export const DoneBackToThePage = 'DoneBackToThePage';
export const BackToThePage = 'BackToThePage';
export const Close = 'Close';
export const YourPersonalizedFormula = 'YourPersonalizedFormula';
export const BasedOnYourDiet = 'BasedOnYourDiet';

export const ThankYouQuizTitle = 'ThankYouQuizTitle';
export const ThankYouQuizIntro = 'ThankYouQuizIntro';
export const ThankYouQuizList1 = 'ThankYouQuizList1';
export const ThankYouQuizList2 = 'ThankYouQuizList2';
export const ThankYouQuizList3 = 'ThankYouQuizList3';
export const GenerateMyFormula = 'GenerateMyFormula';
export const JoinMembersFormula = 'JoinMembersFormula';

export const UnlockFreeGiftsWithSubscription = 'UnlockFreeGiftsWithSubscription';
export const Gratis = 'Gratis';
export const Locked = 'Locked';
export const TravelBag = 'TravelBag';
export const MetalContainer = 'MetalContainer';
export const WellnessGuide = 'WellnessGuide';
export const HabitTracker = 'HabitTracker';
export const Omega3Gift = 'Omega3Gift';
export const Omega3GiftTriple = 'Omega3GiftTriple';
export const FreeShippingEU = 'FreeShippingEU';
export const FreeGiftsWithSubscription = 'FreeGiftsWithSubscription';
export const WelcomeGifts = 'WelcomeGifts';
export const ProofTitle = 'ProofTitle';
export const ProofStat1 = 'ProofStat1';
export const ProofStat2 = 'ProofStat2';
export const ProofStat3 = 'ProofStat3';
export const ProofStat4 = 'ProofStat4';
export const ProofSource = 'ProofSource';
export const HowToEnjoy_Heading = 'HowToEnjoy_Heading';
export const HowToEnjoy_Step1_Title = 'HowToEnjoy_Step1_Title';
export const HowToEnjoy_Step1_Desc = 'HowToEnjoy_Step1_Desc';
export const HowToEnjoy_Step2_Title = 'HowToEnjoy_Step2_Title';
export const HowToEnjoy_Step2_Desc = 'HowToEnjoy_Step2_Desc';
export const HowToEnjoy_Step3_Title = 'HowToEnjoy_Step3_Title';
export const HowToEnjoy_Step3_Desc = 'HowToEnjoy_Step3_Desc';
export const HowToEnjoy_Alt = 'HowToEnjoy_Alt';
export const MysteryExpiredBadge = 'MysteryExpiredBadge';
export const MysteryExpiredMessage = 'MysteryExpiredMessage';

export const HTT_Eyebrow = 'HTT_Eyebrow';
export const HTT_Headline = 'HTT_Headline';
export const HTT_Subhead = 'HTT_Subhead';
export const HTT_Rule_No = 'HTT_Rule_No';
export const HTT_Rule_Yes = 'HTT_Rule_Yes';
export const HTT_Rule_Why = 'HTT_Rule_Why';
export const HTT_Rule_Alt = 'HTT_Rule_Alt';
export const HTT_Rule_Crunch = 'HTT_Rule_Crunch';
export const HTT_Rule_CrunchWhy = 'HTT_Rule_CrunchWhy';
export const HTT_VideoYoghurt = 'HTT_VideoYoghurt';
export const HTT_StepOf = 'HTT_StepOf';
export const HTT_Done = 'HTT_Done';
export const HTT_VideoTitle = 'HTT_VideoTitle';
export const HTT_VideoPlaceholder = 'HTT_VideoPlaceholder';
export const HTT_StepsTitle = 'HTT_StepsTitle';
export const HTT_Consistency = 'HTT_Consistency';
export const HTT_FoundersEyebrow = 'HTT_FoundersEyebrow';
export const HTT_FoundersMessage = 'HTT_FoundersMessage';
export const HTT_FoundersSignature = 'HTT_FoundersSignature';
export const HTT_CheckinEyebrow = 'HTT_CheckinEyebrow';
export const HTT_CheckinTitle = 'HTT_CheckinTitle';
export const HTT_CheckinBody = 'HTT_CheckinBody';
export const HTT_CheckinCTA = 'HTT_CheckinCTA';
export const HTT_Support = 'HTT_Support';

export const HTT_Concept_Eyebrow = 'HTT_Concept_Eyebrow';
export const HTT_Concept_Headline = 'HTT_Concept_Headline';
export const HTT_Brain_TagLeft = 'HTT_Brain_TagLeft';
export const HTT_Brain_PctLeft = 'HTT_Brain_PctLeft';
export const HTT_Brain_TitleLeft = 'HTT_Brain_TitleLeft';
export const HTT_Brain_BodyLeft = 'HTT_Brain_BodyLeft';
export const HTT_Brain_TagRight = 'HTT_Brain_TagRight';
export const HTT_Brain_PctRight = 'HTT_Brain_PctRight';
export const HTT_Brain_TitleRight = 'HTT_Brain_TitleRight';
export const HTT_Brain_BodyRight = 'HTT_Brain_BodyRight';
export const HTT_Brain_Insight = 'HTT_Brain_Insight';
export const HTT_Habit_Eyebrow = 'HTT_Habit_Eyebrow';
export const HTT_Habit_Headline = 'HTT_Habit_Headline';
export const HTT_Habit_Intro = 'HTT_Habit_Intro';
export const HTT_Habit_1_Num = 'HTT_Habit_1_Num';
export const HTT_Habit_1_Title = 'HTT_Habit_1_Title';
export const HTT_Habit_1_Body = 'HTT_Habit_1_Body';
export const HTT_Habit_1_Note = 'HTT_Habit_1_Note';
export const HTT_Habit_2_Num = 'HTT_Habit_2_Num';
export const HTT_Habit_2_Title = 'HTT_Habit_2_Title';
export const HTT_Habit_2_Body = 'HTT_Habit_2_Body';
export const HTT_Habit_2_Note = 'HTT_Habit_2_Note';
export const HTT_Habit_3_Num = 'HTT_Habit_3_Num';
export const HTT_Habit_3_Title = 'HTT_Habit_3_Title';
export const HTT_Habit_3_Body = 'HTT_Habit_3_Body';
export const HTT_Habit_3_Note = 'HTT_Habit_3_Note';

export const HTT_Ritual_CheckinEyebrow = 'HTT_Ritual_CheckinEyebrow';
export const HTT_Ritual_CheckinTitle = 'HTT_Ritual_CheckinTitle';
export const HTT_Ritual_CheckinBody = 'HTT_Ritual_CheckinBody';
export const HTT_Ritual_CheckinBtn = 'HTT_Ritual_CheckinBtn';

export const HTT_Step1_Label = 'HTT_Step1_Label';
export const HTT_Step2_Label = 'HTT_Step2_Label';
export const HTT_Step3_Label = 'HTT_Step3_Label';
export const HTT_Step4_Label = 'HTT_Step4_Label';

export const HTT_TL_Eyebrow = 'HTT_TL_Eyebrow';
export const HTT_TL_Headline = 'HTT_TL_Headline';
export const HTT_TL_W1_Period = 'HTT_TL_W1_Period';
export const HTT_TL_W1_Title = 'HTT_TL_W1_Title';
export const HTT_TL_W1_Body = 'HTT_TL_W1_Body';
export const HTT_TL_M1_Period = 'HTT_TL_M1_Period';
export const HTT_TL_M1_Title = 'HTT_TL_M1_Title';
export const HTT_TL_M1_Body = 'HTT_TL_M1_Body';
export const HTT_TL_M3_Period = 'HTT_TL_M3_Period';
export const HTT_TL_M3_Title = 'HTT_TL_M3_Title';
export const HTT_TL_M3_Body = 'HTT_TL_M3_Body';
export const HTT_TL_M6_Period = 'HTT_TL_M6_Period';
export const HTT_TL_M6_Title = 'HTT_TL_M6_Title';
export const HTT_TL_M6_Body = 'HTT_TL_M6_Body';
export const HTT_TL_VideoEyebrow = 'HTT_TL_VideoEyebrow';
export const HTT_TL_VideoTitle = 'HTT_TL_VideoTitle';

export const HTT_FAQ_Eyebrow = 'HTT_FAQ_Eyebrow';
export const HTT_FAQ_Headline = 'HTT_FAQ_Headline';
export const HTT_FAQ_Cat_1 = 'HTT_FAQ_Cat_1';
export const HTT_FAQ_Cat_2 = 'HTT_FAQ_Cat_2';
export const HTT_FAQ_Cat_3 = 'HTT_FAQ_Cat_3';
export const HTT_FAQ_Cat_4 = 'HTT_FAQ_Cat_4';
export const HTT_FAQ_Contact = 'HTT_FAQ_Contact';
export const HTT_FAQ_1_Q = 'HTT_FAQ_1_Q';
export const HTT_FAQ_1_A = 'HTT_FAQ_1_A';
export const HTT_FAQ_2_Q = 'HTT_FAQ_2_Q';
export const HTT_FAQ_2_A = 'HTT_FAQ_2_A';
export const HTT_FAQ_3_Q = 'HTT_FAQ_3_Q';
export const HTT_FAQ_3_A = 'HTT_FAQ_3_A';
export const HTT_FAQ_4_Q = 'HTT_FAQ_4_Q';
export const HTT_FAQ_4_A = 'HTT_FAQ_4_A';
export const HTT_FAQ_5_Q = 'HTT_FAQ_5_Q';
export const HTT_FAQ_5_A = 'HTT_FAQ_5_A';
export const HTT_FAQ_6_Q = 'HTT_FAQ_6_Q';
export const HTT_FAQ_6_A = 'HTT_FAQ_6_A';
export const HTT_FAQ_7_Q = 'HTT_FAQ_7_Q';
export const HTT_FAQ_7_A = 'HTT_FAQ_7_A';

export const RG_Eyebrow = 'RG_Eyebrow';
export const RG_Headline_Pre = 'RG_Headline_Pre';
export const RG_Headline_Em = 'RG_Headline_Em';
export const RG_Subhead = 'RG_Subhead';
export const RG_Tip_Title = 'RG_Tip_Title';
export const RG_Tip_Body = 'RG_Tip_Body';
export const RG_Tab_Ios = 'RG_Tab_Ios';
export const RG_Tab_Android = 'RG_Tab_Android';
export const RG_Steps_Title = 'RG_Steps_Title';
export const RG_Ios_1 = 'RG_Ios_1';
export const RG_Ios_2 = 'RG_Ios_2';
export const RG_Ios_3 = 'RG_Ios_3';
export const RG_Ios_4 = 'RG_Ios_4';
export const RG_Ios_5 = 'RG_Ios_5';
export const RG_Ios_6 = 'RG_Ios_6';
export const RG_Android_1 = 'RG_Android_1';
export const RG_Android_2 = 'RG_Android_2';
export const RG_Android_3 = 'RG_Android_3';
export const RG_Android_4 = 'RG_Android_4';
export const RG_Android_5 = 'RG_Android_5';
export const RG_Android_6 = 'RG_Android_6';
export const RG_Menu_Note = 'RG_Menu_Note';
export const RG_Done = 'RG_Done';
export const RG_Video_Eyebrow = 'RG_Video_Eyebrow';
export const RG_Video_Title = 'RG_Video_Title';

// Nutrient-clash objection section (product-suggestion page)
export const NutrientClashEyebrow = 'NutrientClashEyebrow';
export const NutrientClashHeading = 'NutrientClashHeading';
export const NutrientClashHeadingEm = 'NutrientClashHeadingEm';
export const NutrientClashLede = 'NutrientClashLede';
export const NutrientClashLeftLabel = 'NutrientClashLeftLabel';
export const NutrientClashLeftCaption = 'NutrientClashLeftCaption';
export const NutrientClashRightLabel = 'NutrientClashRightLabel';
export const NutrientClashRightCaption = 'NutrientClashRightCaption';
export const NutrientClashAtOnce = 'NutrientClashAtOnce';
export const NutrientClashOverTime = 'NutrientClashOverTime';
export const NutrientClashProof1 = 'NutrientClashProof1';
export const NutrientClashProof2 = 'NutrientClashProof2';
export const NutrientClashProof3 = 'NutrientClashProof3';
